import api from '../utils/functions/api';

const baseURL = process.env.REACT_APP_API_URL;

async function getPdfApi(order_id) {
  try {
    const resp = await api.get(`${baseURL}/pdf/invoice/${order_id}`)

    return resp.data;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
}

async function postManualPaidApi(id, date) {
  try {
    const resp = await api.post(`${baseURL}/invoice/manual-paid`, {
      orderId: id,
      payDate: date,
    });

    return resp.data;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
}

async function deleteByIdApi(id) {
  try {
    const resp = await api.delete(`${baseURL}/invoice/deleteById/${id}`);

    return resp.data;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
}

async function deleteManyApi(ids) {
  try {
    const resp = await api.delete(`${baseURL}/invoice/deleteMany`, {
      data: ids.map((id) => ({ _id: id })),
    });

    return resp.data;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
}

async function createInvoiceApi(item) {
  try {
    const resp = await api.post(`${baseURL}/upload/invoice`, {
      data: [
        {
          ...item,
          email: item.email ? item.email.trim() : null,
        },
      ],
    });

    return resp.data;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
}

async function getCustomerListApi() {
  try {
    const resp = await api.get(`${baseURL}/manage-users/get-custormer-list`);

    return resp.data;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
}

async function getInvoiceListApi(
  search,
  start,
  end,
  page,
  rowsPerPage,
  sortBy,
  sendMailOptionList
) {
  try {
    const { data } = await api.get(
      `${baseURL}/invoice/send-email?search=${search}&startDate=${start}&endDate=${end}&page=${
        page + 1
      }&size=${rowsPerPage}&sortBy=${sortBy}&sendMailOptionList=${sendMailOptionList}`,
    );

    return data;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
}

async function uploadInvoiceApi(updatedData) {
  try {
    const { data } = await api.post(`${baseURL}/upload/invoice`, {
      data: updatedData
    });

    return data;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
}

async function extractFileApi(formData) {
  try {
    const { data } = await api.post(`${baseURL}/upload/invoice/extract`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    return data;
  } catch (error) {
    console.log(error);
    throw new Error(error.response.data.error.message);
  }
}

async function getInvoiceDetail(order_id) {
  try {
    const resp = await api.get(`${baseURL}/invoice/detail/${order_id}`)

    return resp.data;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
}

async function postInvoiceJVApi(data) {
  try {
    const resp = await api.post(`${baseURL}/upload/invoice/import`, data );

    return resp.data;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
}

async function postZipPDFApi(orderIdList) {
  try {
    const resp = await api.post(`${baseURL}/pdf/invoice/download-zip`, { 
      orderIdList 
    }, {
      responseType: 'blob',
    }
  );

    return resp;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
}

const InvoiceListApi = {
  getPdfApi,
  postManualPaidApi,
  deleteByIdApi,
  deleteManyApi,
  getCustomerListApi,
  getInvoiceListApi,
  createInvoiceApi,
  uploadInvoiceApi,
  extractFileApi,
  getInvoiceDetail,
  postInvoiceJVApi,
  postZipPDFApi
};
export default InvoiceListApi;
